var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32H0V0H32V32Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5H8V7.5H24V24.5Z",
    stroke: "#E5E7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.5H8V7.5H24V23.5Z",
    stroke: "#E5E7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7063 16.2063C24.0969 15.8156 24.0969 15.1813 23.7063 14.7906L19.7063 10.7906C19.3156 10.4 18.6812 10.4 18.2906 10.7906C17.9 11.1813 17.9 11.8156 18.2906 12.2063L20.5844 14.5H14C13.4469 14.5 13 14.9469 13 15.5C13 16.0531 13.4469 16.5 14 16.5H20.5844L18.2906 18.7937C17.9 19.1844 17.9 19.8188 18.2906 20.2094C18.6812 20.6 19.3156 20.6 19.7063 20.2094L23.7063 16.2094V16.2063ZM13 10.5C13.5531 10.5 14 10.0531 14 9.5C14 8.94687 13.5531 8.5 13 8.5H11C9.34375 8.5 8 9.84375 8 11.5V19.5C8 21.1562 9.34375 22.5 11 22.5H13C13.5531 22.5 14 22.0531 14 21.5C14 20.9469 13.5531 20.5 13 20.5H11C10.4469 20.5 10 20.0531 10 19.5V11.5C10 10.9469 10.4469 10.5 11 10.5H13Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.78c36257591d02505f2322cc43dce020.svg";
export { ForwardRef as ReactComponent };